import type {
  MoodOption,
  ActivityOption,
  CommunityOption,
} from '../types';

// PlaceTypes entfernt - ersetzt durch MainCategory in types/index.ts

export const MOODS: MoodOption[] = [
  { label: 'Ruhig & entspannt', icon: '🧘' },
  { label: 'Lebendig & gesellig', icon: '🎉' },
  { label: 'Kreativ & inspirierend', icon: '💡' },
  { label: 'Gemütlich & vertraut', icon: '🏡' },
  { label: 'Offen & einladend', icon: '👋' },
  { label: 'Traditionell & authentisch', icon: '🍺' },
];

export const ACTIVITIES: ActivityOption[] = [
  { label: 'Einfach da sein', icon: '☕' },
  { label: 'Lesen & Schmökern', icon: '📚' },
  { label: 'Plaudern & Zuhören', icon: '💬' },
  { label: 'Spielen (Karten, Brettspiele)', icon: '🎲' },
  { label: 'Neue Menschen kennenlernen', icon: '👥' },
  { label: 'Stammtisch besuchen', icon: '🍻' },
  { label: 'Events & Veranstaltungen', icon: '🎭' },
  { label: 'Kreativ sein', icon: '🎨' },
];

export const COMMUNITY_FEATURES: CommunityOption[] = [
  { label: 'Stammtisch vorhanden', icon: '📅' },
  { label: 'Regelmäßige Treffen', icon: '🔄' },
  { label: 'Offene Runde', icon: '⭕' },
  { label: 'Nachbarschaftstreff', icon: '🏘️' },
  { label: 'Generationen-Mix', icon: '👴👶' },
  { label: 'Haustiere willkommen', icon: '🐕' },
  { label: 'Kinder willkommen', icon: '👶' },
  { label: 'Barrierefrei', icon: '♿' },
];

export const WEEKDAYS = [
  { key: 'monday', label: 'Montag', short: 'Mo' },
  { key: 'tuesday', label: 'Dienstag', short: 'Di' },
  { key: 'wednesday', label: 'Mittwoch', short: 'Mi' },
  { key: 'thursday', label: 'Donnerstag', short: 'Do' },
  { key: 'friday', label: 'Freitag', short: 'Fr' },
  { key: 'saturday', label: 'Samstag', short: 'Sa' },
  { key: 'sunday', label: 'Sonntag', short: 'So' },
] as const;

// Helper to get icon for a mood
export function getMoodIcon(label: string): string {
  return MOODS.find((m) => m.label === label)?.icon || '✨';
}

// Helper to get icon for an activity
export function getActivityIcon(label: string): string {
  return ACTIVITIES.find((a) => a.label === label)?.icon || '🎯';
}

// Helper to get icon for a community feature
export function getCommunityIcon(label: string): string {
  return COMMUNITY_FEATURES.find((c) => c.label === label)?.icon || '👥';
}
